import { render, staticRenderFns } from "./DetailBackTop.vue?vue&type=template&id=5b9625de&scoped=true&"
import script from "./DetailBackTop.vue?vue&type=script&lang=js&"
export * from "./DetailBackTop.vue?vue&type=script&lang=js&"
import style0 from "./DetailBackTop.vue?vue&type=style&index=0&id=5b9625de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9625de",
  null
  
)

export default component.exports